module.exports = __webpack_public_path__ + "img/CM-DJ-25-Nissan-Established.5c9e925f.jpg";